import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}carts`;

export const addCart = (product) => {
    const token = localStorage.getItem('token');

    return axios.post(API_URL, product, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const updateCart = (id, product) => {
    const token = localStorage.getItem('token');

    return axios.patch(`${API_URL}/${id}`, product, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const getCartsById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const getCartsByIdUser = () => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/cart/by-user-cart`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const removeCartsById = (id) => {
    const token = localStorage.getItem('token');

    return axios.delete(`${API_URL}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}
